var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "scan-animation" }, [
    _c("div", { staticClass: "scanner" }, [
      _c(
        "div",
        { staticClass: "sheet" },
        _vm._l(_vm.sheetLines, function (w, i) {
          return _c("span", {
            key: i,
            staticClass: "sheet-line",
            style: { width: w },
          })
        }),
        0
      ),
      _c("div", { staticClass: "beam" }),
    ]),
    _vm.text
      ? _c("div", { staticClass: "scan-text" }, [
          _vm._v(" " + _vm._s(_vm.text) + " "),
          _vm._m(0),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "dots" }, [_c("i"), _c("i"), _c("i")])
  },
]
render._withStripped = true

export { render, staticRenderFns }